import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseSepaMandateFailedTemplates = [
  {
    id: '-136001',
    language: Language.EN,
    subject: 'Your direct debit mandate could not be set up',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_MANDATE_FAILED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>The direct debit mandate for the lease at <strong>{{getLeaseMainAddress lease}}</strong> could not be set up{{#if sepaFailureReason}} (reason: {{sepaFailureReason}}){{/if}}.</p>
        <p>As a result, no automatic collection will take place. Please set up the mandate again, or contact us so that we can send you a new mandate link.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-136002',
    language: Language.FR,
    subject: "Votre mandat de domiciliation n'a pas pu être créé",
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_MANDATE_FAILED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Le mandat de domiciliation pour le bail sis <strong>{{getLeaseMainAddress lease}}</strong> n'a pas pu être créé{{#if sepaFailureReason}} (motif : {{sepaFailureReason}}){{/if}}.</p>
        <p>Par conséquent, aucun prélèvement automatique ne sera effectué. Veuillez à nouveau mettre en place le mandat, ou contactez-nous afin que nous puissions vous envoyer un nouveau lien de mandat.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
    `,
  },
  {
    id: '-136003',
    language: Language.NL,
    subject: 'Uw domiciliëringsmandaat kon niet worden ingesteld',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_MANDATE_FAILED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Het domiciliëringsmandaat voor de huurovereenkomst op <strong>{{getLeaseMainAddress lease}}</strong> kon niet worden ingesteld{{#if sepaFailureReason}} (reden: {{sepaFailureReason}}){{/if}}.</p>
        <p>Hierdoor zal er geen automatische inning plaatsvinden. Gelieve het mandaat opnieuw in te stellen, of neem contact met ons op zodat wij u een nieuwe mandaatlink kunnen sturen.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-136004',
    language: Language.DE,
    subject: 'Ihr Lastschriftmandat konnte nicht eingerichtet werden',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_SEPA_MANDATE_FAILED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Das Lastschriftmandat für den Mietvertrag unter <strong>{{getLeaseMainAddress lease}}</strong> konnte nicht eingerichtet werden{{#if sepaFailureReason}} (Grund: {{sepaFailureReason}}){{/if}}.</p>
        <p>Daher findet kein automatischer Einzug statt. Bitte richten Sie das Mandat erneut ein, oder kontaktieren Sie uns, damit wir Ihnen einen neuen Mandatslink zusenden können.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
